export default {
    namespaced: true,
    state: {
        aporte: null,
        totalBomberos: null
    },
    mutations: {
        actualizarAporte(state, aporte) {
            state.aporte = aporte;
        },
        actualizarTotalBomberos(state, totalBomberos) {
            state.totalBomberos = totalBomberos;
        }
    },
    actions: {
        actualizarAporte({
            commit
        }, payload) {
            commit("actualizarAporte", 0);
            commit("actualizarTotalBomberos", payload);
        },
        actualizarTotalBomberos({
            commit
        }, payload) {
            commit("actualizarTotalBomberos", payload);
        },
        resetearTrxBomberos({
            commit
        }, payload) {
            commit("actualizarAporte", 0);
            commit("actualizarTotalBomberos", 0);
        }
    }
}
